import React from "react"

export default function EnumOption<Type extends string>({value, children}: { value: Type, children?: React.ReactNode }) {
    return <option value={value}>{children}</option>
}
